import React from 'react';
import GoogleLogo from '../../assets/google-logo.svg.svg';
import AppleLogo from '../../assets/apple-logo.svg.svg'; 
import './Home.css';
import SignLogo from '../../assets/sign_up.png';
import {
	Box,
	Typography,
	Card,
	styled,
	Button,
	Divider,
} from '@mui/material';
import { Link } from 'react-router-dom';

const GoogleButton = styled(Button)(
	({ theme }) => `
	border-radius: 8px;
	padding: 12px 16px;
	font-size: 0.875rem;
	background: transparent;
	border: 1px solid #E0E0E0;
	color: #333;
	width: 100%;
	margin-bottom: 12px;
	text-transform: none;
	font-weight: 500;
	position: relative;
	justify-content: center;
	
	&:hover {
		background: #F8F9FA;
		border-color: #DADCE0;
	}
	
	.MuiButton-startIcon {
		position: absolute;
		left: 16px;
		margin-right: 0;
	}
	`
);

const AppleButton = styled(Button)(
	({ theme }) => `
	border-radius: 8px;
	padding: 12px 16px;
	font-size: 0.875rem;
	background: transparent;
	border: 1px solid #E0E0E0;
	color: #333;
	width: 100%;
	margin-bottom: 20px;
	text-transform: none;
	font-weight: 500;
	position: relative;
	justify-content: center;
	
	&:hover {
		background: #F8F9FA;
		border-color: #DADCE0;
	}
	
	.MuiButton-startIcon {
		position: absolute;
		left: 16px;
		margin-right: 0;
	}
	`
);

const EmailButton = styled(Button)(
	({ theme }) => `
	border-radius: 8px;
	padding: 12px 16px;
	font-size: 0.875rem;
	background: #0040BF;
	color: white;
	width: 100%;
	text-transform: none;
	font-weight: 600;
	
	&:hover {
		background: #1565C0;
	}
	`
);

const Home = () => {
	return (
		<Box 
		   sx={{
         minHeight: '100vh',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         backgroundImage: `url(${SignLogo})`,
         backgroundSize: 'cover',
         backgroundPosition: 'center',
         backgroundRepeat: 'no-repeat',
         padding: { xs: 1, sm: 3, md: 4 },
       }}
		>
			<Card
				 sx={{
                  width: {
                     xs: '100%',    
                     sm: '60%',     
                     md: '50%',     
                     lg: '30%',   
                     xl: '20%',  
                   },
                  marginX: 'auto',
                  paddingX: '25px',
                  height: 'fit',
                  paddingBottom:'20px',
                  backgroundColor: 'white',
                  borderRadius: 1,
               }}
			>
				{/* Header */}
				<Typography
				className='font-cormorant'
					variant="h4"
					sx={{
						
						fontWeight: 600,
						color: '#2E2C21',
						marginBottom: '8px',
					    paddingTop:'2rem',
						fontSize:{ xs: '1.5rem', sm: '2.3rem'}
					}}
				>
					Sign up for free in seconds
				</Typography>

				{/* Login Link */}
				<Typography
					variant="body2"
					sx={{
						
						color: '#2E2C21',
						marginBottom: '32px',
						fontWeight:'400'
					}}
				>
					Already have an account?{' '}
					<Link 
						to="/login" 
						style={{ 
							color: '#0040BF', 
							textDecoration: 'none',
							fontWeight: 400 
						}}
					>
						Login
					</Link>
				</Typography>

				{/* Social Login Buttons */}
				<Box sx={{ marginBottom: '24px' }}>
					<GoogleButton
	sx={{
		color:'#2E2C21'
	}}
>
	<img 
		src={GoogleLogo} 
		alt="Google" 
		style={{
			position: 'absolute',
			left: '16px',
			width: '20px',
			height: '20px'
		}}
	/>
	Continue with Google
</GoogleButton>

<AppleButton
	sx={{
		color:'#2E2C21'
	}}
>
	<img 
		src={AppleLogo} 
		alt="Apple" 
		style={{
			position: 'absolute',
			left: '16px',
			width: '20px',
			height: '20px'
		}}
	/>
	Continue with Apple
</AppleButton>
				</Box>

				{/* OR Divider */}
				<Box 
					sx={{ 
						display: 'flex', 
						alignItems: 'center', 
						marginBottom: '24px',
						
					}}
				>
					<Divider sx={{ flex: 1,background:'#d5d5d2' }} />
					<Typography 
						variant="body2" 
						sx={{ 
							marginX: '16px', 
							color: '#2E2C21',
							fontSize: '0.875rem'
						}}
					>
						OR
					</Typography>
					<Divider sx={{ flex: 1, background:'#d5d5d2'  }} />
				</Box>

				{/* Email Signup Button */}
				<Link to="/signup" style={{ textDecoration: 'none' }}>
					<EmailButton
						
					>
						Continue with email
					</EmailButton>
				</Link>
			</Card>
		</Box>
	);
};

export default Home;